import React, { useState } from "react";
import Swal from "sweetalert2";
import swal from "sweetalert";
import PageTitle from "../../../jsx/layouts/PageTitle";
import { CiFilter, CiSearch } from "react-icons/ci";
import { Modal } from "react-bootstrap";
import {
    addSingleTicketResponse,
    getGrievanceAllTicket,
    getpublicGrievance,
    getSingleData,
    updatepublicStausAndPriority,
    updateStausAndPriority,
} from "../../../services/adminApiService/grievanceTicket/grievanceTicketApis";

import PaginationComp from "../../../common/ui/view/pagination/PaginationComp";
import { Button, FormControl, InputGroup, Nav } from "react-bootstrap";
import moment from "moment";
import ViewTicket from "../../../admin/admincomponent/ticket/ViewTicket";

export const formatOFTicketRegex = /.(jpe?g|png)$/i;
// const allowedCharsRegex = /^[a-zA-Z0-9?()&'\-,.\s]*$/;
const allowedCharsRegex = /^.*$/;

//colors
const getStatusColor = (status) => {
    switch (status) {
        case "in_progress":
            return "#FFA500"; // Orange
        case "Resolved":
            return "#4CAF50"; // Green
        case "closed":
            return "#808080"; // Gray
        case "Reopened":
            return "#FF4500"; // Dark Orange/Red
        case "low":
            return "#00BFFF"; // Light Blue
        case "Medium":
            return "#FFD700"; // Gold
        case "high":
            return "#FF8C00"; // Dark Orange
        case "Critical":
            return "#FF0000"; // Red
        case "New":
            return "#FF0000"; // Red
        default:
            return "#000000"; // Black as fallback
    }
};

const filterForm = {
    priority: "",
    status: "",
};

const PublicGrievance = () => {
    const [filterFormValues, setfilterFormValues] = React.useState(filterForm);
    const [toggleSearchAndFilter, settoggleSearchAndFilter] =
        React.useState("filter");
    const [searchValue, setsearchValue] = React.useState("");
    // filter states end
    const [currentpage, setCurrentPage] = React.useState(1); //current pages
    const [totalPages, setTotalPages] = React.useState(null); //total pages
    const [uploadedFile, setUploadedFile] = React.useState(null); //grab file
    const [viewTicketData, setviewTicketData] = React.useState({});
    const [data, setData] = React.useState({});
    const [responseText, setResponseText] = React.useState("");
    const [currentChatId, setcurrentChatId] = React.useState(null);
    const [isLoading, setisLoading] = React.useState(false);
    const [error, setError] = React.useState({ replyCommentBox: "" });
    const [show, setshow] = React.useState(false);
    const [selectedTickedDeatils, setselectedTickedDeatils] = React.useState({});
    const debounceRef = React.useRef(null);
    const selectedTicketRef = React.useRef(null);
    const [showModal, setShowModal] = useState(false);
    const [selectedDescription, setSelectedDescription] = useState("");


     const handleShow = (description) => {
        setSelectedDescription(description);
        setShowModal(true);
    };

    // const handleClose = () => {
    //     setShowModal(false);
    //     setSelectedDescription("");
    // };
    //fetch tickets
    const fetchAllpublicgrievance = React.useCallback(async (currentpage, payload) => {
        try {
            let res = await getpublicGrievance({ currentpage, ...payload });
            setTotalPages(res?.data?.data?.last_page);
            setData(res?.data?.data);
        } catch (error) {
            console.log(error.message);
        }
    }, []);
    React.useEffect(() => {
        fetchAllpublicgrievance(currentpage);
    }, [currentpage, fetchAllpublicgrievance]);
    //   handle View Ticket
    const handleViewTicket = async (index, item) => {
        setselectedTickedDeatils(item);
        selectedTicketRef.current = item;
        setcurrentChatId(item?.id);
        setshow(true);
        let res = await getSingleData(item?.id);
        if (res?.data?.status) setviewTicketData(res?.data?.data);
    };

    const handleResponseText = (e) => {
        let { name, value } = e.target;
        value = value.trimStart();
        setResponseText(e.target.value);
        if (!allowedCharsRegex.test(value)) {
            setError({
                ...error,
                [name]:
                    "Invalid characters detected. Only ? ( ) - ' & . , are allowed.",
            });
        } else {
            setError("");
        }
    };
    const handleSubmitResponse = async (id) => {
        if (!responseText && !uploadedFile) {
            return;
        }

        if (Object.keys(error).length > 0) {
            return;
        }
        // submit the response

        let formData = new FormData();
        formData.append("description", responseText);
        uploadedFile && formData.append("attachement", uploadedFile);
        formData.append("id", id);
        setisLoading(true);
        try {
            let res = await addSingleTicketResponse(formData);
            if (res?.data?.status) {
                await handleViewTicket("_", selectedTicketRef.current);
                setResponseText("");
                setUploadedFile(null);
            }
        } catch (error) {
            console.log(error);
        } finally {
            setisLoading(false);
        }
    };

    //handle status
    const handleStatusOfTicket = (e, { id }) => {
        if (!e.target.value) {
            return;
        }
        Swal.fire({
            title: "",
            text: "Are you sure you want to update the status?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, update it!",
            cancelButtonText: "No, cancel",
        }).then(async (result) => {
            if (result.isConfirmed) {
                let res = await updatepublicStausAndPriority({
                    id,
                    status: e.target.value,
                });

                if (res?.data?.status) {
                    swal(res?.data?.message, {
                        icon: "success",
                    });
                    fetchAllpublicgrievance(currentpage);
                } else {
                    swal(res?.data?.message, {
                        icon: "success",
                    });
                }
            } else {
                swal("Your Status is not upated", {
                    icon: "success",
                });
            }
        });
    };

    //handle priorty level
    const handlePriotityOfTicket = (e, { id }) => {
        if (!e.target.value) {
            return;
        }
        Swal.fire({
            title: "",
            text: "Are you sure you want to update the priority?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, update it!",
            cancelButtonText: "No, cancel",
        }).then(async (result) => {
            if (result.isConfirmed) {
                if (result.isConfirmed) {
                    let res = await updatepublicStausAndPriority({
                        id,
                        priority: e.target.value,
                    });

                    if (res?.data?.status) {
                        swal(res?.data?.message, {
                            icon: "success",
                        });
                        fetchAllpublicgrievance(currentpage);
                    } else {
                        swal(res?.data?.message, {
                            icon: "success",
                        });
                    }
                }
            } else {
                swal("Your Priority is not upated", {
                    icon: "success",
                });
            }
        });
    };

    //handle CHat Dialog
  const handleClose = () => {
     setShowModal(false);
    setshow(false);
    setSelectedDescription("");
};

    ///handle Filters of admin tickets
    const handleChangeFilterValues = (e) => {
        const { name, value } = e.target;
        setfilterFormValues({ ...filterFormValues, [name]: value });
    };
    const handleFilterFormValues = (e) => {
        e.preventDefault();
        let checkAtleastOneIstruthy = Object.values(filterFormValues).some((ele) =>
            Boolean(ele)
        );
        if (checkAtleastOneIstruthy) {
            fetchAllpublicgrievance(currentpage, filterFormValues);
        } else {
            return;
        }
    };

    const resetFilter = () => {
        setfilterFormValues(filterForm);
        fetchAllpublicgrievance(currentpage);
    };

    //handlr search value
    const handleSearchValue = (e) => {
        // if (!e.target.value.trim()) return;
        let value = e.target.value.trim();
        if (debounceRef.current) {
            clearTimeout(debounceRef.current);
        }

        debounceRef.current = setTimeout(() => {
            if (value) {
                setsearchValue(value);

                fetchAllpublicgrievance(currentpage, { search: value });
            } else {
                fetchAllpublicgrievance(currentpage);
            }
        }, 500);
    };
    //handle toggle for filter and search
    function handleToggle(value) {
        if (value === toggleSearchAndFilter) {
            return;
        }
        settoggleSearchAndFilter(value);
    }
    return (
        <>
            <PageTitle
                activeMenu="Public Grievence"
                motherMenu="Grievance-Management"
            />

            <div className="card">
                <div className="card-body">
                    <div className="row mb-3">
                        <form onSubmit={handleFilterFormValues}>
                            <div className="row mb-3">
                                {toggleSearchAndFilter === "filter" ? (
                                    <>
                                        <div className="col-lg-2 ms-lg-3">
                                            <label>Priority</label>
                                            <select
                                                className={`form-control`}
                                                name="priority"
                                                onChange={handleChangeFilterValues}
                                                value={filterFormValues.priority}
                                            >
                                                <option value={""}>Select Priority</option>
                                                <option value={"low"}>Low</option>
                                                <option value={"medium"}>Medium</option>
                                                <option value={"high"}> High</option>
                                                {/* <option value={"Critical"}>Critical</option> */}
                                            </select>
                                        </div>
                                        <div className="col-lg-2  ms-lg-3">
                                            <label>Status</label>
                                            <select
                                                value={filterFormValues.status}
                                                className={`form-control`}
                                                name="status"
                                                onChange={handleChangeFilterValues}
                                            >
                                                <option value={""}>Select Status</option>
                                                <option value={"in_progress"}>In Progress</option>
                                                <option value={"resolved"}>Resolved</option>
                                                <option value={"closed"}> Closed</option>
                                                {/* <option value={"Reopened"}>Reopen</option> */}
                                            </select>
                                        </div>

                                        <div className="col-lg-1 d-flex align-items-end ms-lg-3">
                                            <Button type="submit">Search</Button>
                                        </div>
                                        <div className="col-lg-1 d-flex align-items-end ">
                                            <Button onClick={resetFilter}>Reset</Button>
                                        </div>
                                        <div className="col-lg-5"></div>
                                    </>
                                ) : (
                                    <>
                                        <div className="col-lg-4">
                                            <div className="form-group">
                                                <label>Search </label>
                                                <InputGroup>
                                                    <FormControl
                                                        type="text"
                                                        className="form-control input-default"
                                                        placeholder="Search"
                                                        onChange={handleSearchValue}
                                                    />
                                                    {/* <InputGroup.Text onClick={() => {}}>
                            <FaSearch />
                          </InputGroup.Text> */}
                                                </InputGroup>
                                            </div>
                                        </div>
                                        <div className="col-lg-7"></div>
                                    </>
                                )}

                                {/* Icons for Filter and Search */}
                                {/* <div className="col-lg-1 d-flex align-items-end">
                                    <div className="d-flex align-items-center p-2 gap-2">
                                        <CiFilter
                                            size={30}
                                            onClick={() => handleToggle("filter")}
                                            style={{
                                                cursor: "pointer",
                                                color:
                                                    toggleSearchAndFilter === "filter"
                                                        ? "var(--primary)"
                                                        : "",
                                            }}
                                        />
                                        <CiSearch
                                            size={30}
                                            onClick={() => handleToggle("search")}
                                            style={{
                                                cursor: "pointer",
                                                color:
                                                    toggleSearchAndFilter === "search"
                                                        ? "var(--primary)"
                                                        : "",
                                            }}
                                        />
                                    </div>
                                </div> */}
                            </div>
                        </form>
                    </div>
                </div>
            </div>

            <div className="col-12">
                <div className="card">
                    <div className="card-body">
                        <div className="w-100 table-responsive">
                            <div id="example_wrapper" className="dataTables_wrapper">
                                <table id="example" className="display w-100 dataTable">
                                    <thead>
                                        <tr>
                                            <th>SN</th>
                                            <th>Name</th>
                                            <th>Contact No.</th>
                                            <th>Email</th>
                                            <th>Title</th>
                                            <th>Description</th>
                                            <th>Status</th>
                                            <th>Priority</th>
                                            <th>Update Status</th>
                                            <th>Update Priority</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data?.data?.length > 0 ? (
                                            data?.data?.map((item, index) => (
                                                <tr key={index}>
                                                    <td>{(currentpage - 1) * 10 + index + 1}</td>

                                                    <td>{item.name}</td>
                                                    <td>
                                                        {item.mobile || 'N/A'} 
                                                    </td>
                                                    <td>
                                                        {item.email}
                                                    </td>
                                                    <td>{item.title}</td>


                                                    <td
                                                        className="text-wrap"
                                                        style={{ maxWidth: "200px" }}
                                                    >
                                                        {item.description?.length > 50 ? (
                                                            <>
                                                                {item.description.substring(0, 50)}...
                                                                <span
                                                                    onClick={() =>
                                                                        handleShow(item.description)
                                                                    }
                                                                    style={{
                                                                        color: "blue",
                                                                        cursor: "pointer",
                                                                        marginLeft: "5px",
                                                                        textDecoration: "underline",
                                                                    }}
                                                                >
                                                                    More
                                                                </span>
                                                            </>
                                                        ) : (
                                                            item.description
                                                        )}
                                                    </td>
                                                    <td style={{ color: getStatusColor(item.status) }}>
                                                        {item.status === "in_progress"
                                                            ? "In Progress"
                                                            : item.status}
                                                    </td>
                                                    <td
                                                        style={{
                                                            color: getStatusColor(item.priority),
                                                        }}
                                                    >
                                                        {item.priority}
                                                    </td>

                                                    <td>
                                                        <select
                                                            onChange={(e) => handleStatusOfTicket(e, item)}
                                                            className="form-select form-select-sm"
                                                        >
                                                            <option value={""}>Select Status</option>
                                                            <option value={"in_progress"}>In Progress</option>
                                                            <option value={"resolved"}>Resolved</option>
                                                            <option value={"closed"}> Closed</option>
                                                            {/* <option value={"Reopened"}>Reopen</option> */}
                                                        </select>
                                                    </td>
                                                    <td>
                                                        <select
                                                            className="form-select form-select-sm"
                                                            onChange={(e) => handlePriotityOfTicket(e, item)}
                                                        >
                                                            <option value={""}>Select Priority</option>
                                                            <option value={"low"}>Low</option>
                                                            <option value={"medium"}>Medium</option>
                                                            <option value={"high"}> High</option>
                                                            {/* <option value={"Critical"}>Critical</option> */}
                                                        </select>
                                                    </td>

                                                </tr>
                                            ))
                                        ) : (
                                            <tr>
                                                <td colSpan="6" className="text-center">
                                                    Data is not available
                                                </td>
                                            </tr>
                                        )}
                                    </tbody>
                                </table>
                                <div className="d-flex justify-content-center py-2">
                                    <PaginationComp
                                        size={totalPages}
                                        setCurrentPage={setCurrentPage}
                                        currentpage={currentpage}
                                        gutter={true}
                                        variant={""}
                                        bg={true}
                                        circle={true}
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <div className="col-12">
                <div className="card">
                    <ViewTicket
                        // selectedTickedDeatils={selectedTickedDeatils}
                        selectedTickedDeatils={
                            selectedTickedDeatils || selectedTicketRef.current
                        }
                        show={show}
                        handleClose={handleClose}
                        // currentChatId={currentChatId}
                        currentChatId={
                            selectedTickedDeatils?.id || selectedTicketRef.current?.id
                        }
                        isLoading={isLoading}
                        showfor={"admin"}
                        onChangeFunc={handleResponseText}
                        value={responseText}
                        viewTicketData={viewTicketData}
                        handleSubmitResponse={handleSubmitResponse}
                        setUploadedFile={setUploadedFile}
                        uploadedFile={uploadedFile}
                        handleViewTicket={handleViewTicket}
                        error={error}
                    />
                </div>
            </div>


            {/* Modal */}
            <Modal show={showModal} onHide={handleClose} centered>
                <Modal.Header closeButton>
                    <Modal.Title>Description</Modal.Title>
                </Modal.Header>

                <Modal.Body>
                    <p>{selectedDescription}</p>
                </Modal.Body>
            </Modal>
        </>
    )
}

export default PublicGrievance